import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { FC, useState } from 'react';
import { TextField, Button, Box, Typography } from '@mui/material';
import { toast } from 'sonner';
import { SubTitleText } from '../SubTitleText';

interface SendPolicyToMailFormProps {
    sendQuoteToMailForm: (email: string) => Promise<void>;
}

interface FormData {
    emailAddress: string;
}

const validationSchema = Yup.object().shape({
    emailAddress: Yup.string()
        .required('Email is required')
        .email('Invalid email format')
        .matches(/^[\w.+-]+@[a-zA-Z\d.-]+\.[a-zA-Z]{2,}$/, 'Email should only contain valid characters')
});

export const SendPolicyToMailForm: FC<SendPolicyToMailFormProps> = ({ sendQuoteToMailForm }) => {
    const {
        register,
        handleSubmit,
        formState: { errors }
    } = useForm<FormData>({
        resolver: yupResolver(validationSchema)
    });

    const [isLoading, setIsLoading] = useState<boolean>(false);

    const handleOnClick = async (data: FormData) => {
        try {
            setIsLoading(true);
            await sendQuoteToMailForm(data.emailAddress);
        } catch (error) {
            toast.error('Could not send Policy to email');
        } finally {
            setIsLoading(false); // Reset loading state
        }
    };

    return (
        <Box className="space-y-3">
            <SubTitleText text="Send Policy To Email" />
            <Typography>Please fill in your names</Typography>
            <Box component="form" onSubmit={handleSubmit(handleOnClick)} sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                <TextField
                    id="emailAddress"
                    label="Email Address"
                    variant="outlined"
                    type="email"
                    {...register('emailAddress')}
                    error={!!errors.emailAddress}
                    helperText={errors.emailAddress ? errors.emailAddress.message : ''}
                />
                <Button disabled={isLoading} type="submit" variant="contained" color="primary">
                    {isLoading ? 'Submitting...' : 'Submit'}
                </Button>
            </Box>
        </Box>
    );
};
